module.exports = __webpack_public_path__ + "static/img/ingenta-logo.4c8fa1bd.png";